const ja = {
  common: {
    'productIntroduction': "製品紹介",
    'cardPayment': "カード決済",
    'subscriptionPayments': "定期購入のお支払い",
    'linkPayments': "リンク支払い",
    'bnpl': "今すぐ購入、後で支払い",
    'dcc': "動的な通貨換算",
    'checkoutDemo': "チェックアウトのデモ",
    'solutions': "解決",
    'gamingSolutions': "ゲームソリューション",
    'E-commerceSolutions': "Eコマースソリューション",
    'resources': "リソース",
    'support': "サポート",
    'integration': "アクセスガイド",
    'api': "APIドキュメント",
    'FAQ': "よくある質問",
    'paymentMethods': "支払方法",
    'login': "ログイン",
    'contactUs': "お問い合わせ",
    'about': "について",
    'aboutUs': "私たちについて",
    'newsCenter': "インフォメーションセンター",
    'privacyPolicy': "プライバシーポリシー",
    'emailSupport': "電子メールによるヘルプ",
    'cookie': "クッキーポリシー",
    'socialMedia': "ソーシャルメディア",
    register: "今すぐ登録してください",
    copy: "© 2015-2025 checkout.pingpongx.com.杭州ピンポンインテリジェントテクノロジー株式会社の著作権はすべて留保されます。浙江省ICP番号15025700-1。ビジネスライセンス: Hezi B2-20200174 浙江省公安ネットワーク No. 33010802003226",
    customerSupport: "カスタマーサービスに関するご相談"
  },
  index: {
    title: "ピンポンのグローバル買収",
    slogan1: "境界線のない支払い",
    slogan2: "企業がより自由にグローバル化できるようにする",
    desc1: "世界6大カードグループと直結",
    desc2: "地元の銀行と決済機関をサポートする",
    data1: "事業対象国と地域",
    data2: "取引対象通貨",
    data3: "グローバルライセンスおよび資格認可（件）",
    data4: "年換算取引高（米ドル）",
    based: "*データ統計は 2024 年末までに更新されました",
    register: "今すぐ登録してください",
    contactUs: "お問い合わせ",
    globalText: "グローバルパートナー",
    payMethods: {
      title: "世界中の消費者が好む支払い方法に対応します",
      content: "",
      number: '160種類以上の',
      content1: "グローバル決済手段にスムーズに接続",
      content2: "",
      label: "現地で最も人気のある支払い方法",
      more: "支払い方法を見る"
    },
    solution: {
      slogan1: "豊富な支払いオプション",
      slogan2: "より良いユーザーの支払いエクスペリエンスを作成する",
      paynow: "即時支払い",
      paynowDesc1: "ワンクリックでアクセス、世界をカバーする 6 つの主要なデッキ",
      paynowDesc2: "カードレス決済で注文コンバージョン率がさらに向上",
      more: "もっと詳しく知る",
      bnpl: "今すぐ購入、後で支払い",
      bnplDesc1: "今すぐ未来を楽しんでください。支払いは後で",
      bnplDesc2: "さまざまな期間に柔軟な選択をサポート",
      subscription: "定期購入のお支払い",
      subscriptionDesc1: "加入者はカードを簡単にバインドできます",
      subscriptionDesc2: "支払いサイクルはいつでも調整できます"
    },
    guard: {
      title: "ビジネス動脈を総合的に保護",
      intelligent: "スマートな支払い",
      intelligentSubTitle: "ユーザーのコンバージョンを向上させる動的最適化の成功率",
      intelligentDesc1: "決済環境の多次元パラメータのリアルタイム分析",
      intelligentDesc2: "チャネルの混雑とリスクノードを自動的に回避",
      security: "システムセキュリティ",
      securitySubTitle: "フルリンクの財務セキュリティ",
      based: "※PingPongテクノロジーシステムに基づく統計ソース",
      securityDesc1: "PCI DSS+SOC2の二重認証保証",
      securityDesc2: "99.99% のシステム安定性*",
      risk: "リスクの予防",
      riskSubTitle: "リスクサーキットブレーカーのインテリジェントな保護",
      riskDesc1: "多層のリアルタイムのリスク制御および保護ネットワークを構築する",
      riskDesc2: "異常な取引行動の特徴を正確に特定する",
      services: "プロフェッショナルサービス",
      servicesSubTitle: "24時間365日の保護と専門家の対応",
      servicesDesc1: "異常な支払いに対する多段階の保護メカニズム",
      servicesDesc2: "フルシナリオのソリューション経験"
    },
    mode: {
      title: "3 つの統合モード",
      title1: "オンライン決済をすぐに開始できるように支援します",
      document: "ドキュメントを見る",
      hosted: "ホストされている",
      hostedDesc: "迅速なオンライン支払い回収システムを開発する必要はありません",
      hostedDesc1: "主流の支払い方法の自動集約",
      embedded: "埋め込み",
      embeddedDesc: "理想的な決済インターフェースを内蔵",
      embeddedDesc1: "ユーザーの支払いエクスペリエンスを向上させる",
      api: 'API',
      apiDesc: "カスタマイズされたフルプロセスの支払い処理ロジック",
      apiDesc1: "複雑なビジネスシナリオのニーズを満たす"
    },
    blog: {
      title: "世界的な買収動向に関連するニュース",
      desc: "業界の洞察を取得し、最新の決済テクノロジーについて学びます。",
      desc1: "新興市場への拡大とビジネス競争力の包括的な強化を支援します。",
      more: "もっと見る"
    },
    faq: {
      title: "よくある質問",
      more: "よくある質問をもっと見る"
    },
    contactTitle: "世界中で注文の取得を直ちに開始"
  },
  cardPayment: {
    title: "カード決済",
    desc1: "6つの主要デッキに直結",
    desc2: "世界中のユーザーにリーチする",
    content: "6 つの主要な国際カード グループをサポートします。世界中の主要なローカルカードグループをカバー",
    content2: '',
    support: "マルチシナリオ決済をサポート",
    increase: "ビジネス収益の増加",
    eCommerce: "越境電子商取引",
    eCommerceDesc: "ワンクリックのグローバルコレクション",
    eCommerceDesc1: "加盟店が障壁なく国際市場を拡大できるよう支援する",
    game: "ゲームのリチャージ",
    gameDesc: "複数のゲーム支払いシナリオをサポート",
    gameDesc1: "ゲーム販​​売者がコストを削減し、効率を向上できるよう支援します",
    ota: "教育・AIなど",
    otaDesc: "より多くの業界や決済ニーズに適用可能",
    cardDesc1: "カードが 1 枚あれば、負けてもすぐに勝つことができます。",
    cardDesc2: "国境を越えても安心",
    concactTitle: "カード支払いを迅速にロック解除してビジネスの成長を促進"
  },
  subscriptionPayment: {
    title: "定期購入のお支払い",
    desc1: "スマートな定期購読",
    desc2: "収入をより安定させる",
    content1: "失敗時に自動的に再試行してユーザーの損失を軽減します",
    content2: "複合サブスクリプション（週払い・月払い・年払い）の一元管理と柔軟な調整",
    support: "複数の販売モデルを柔軟にマッチング",
    stream: "ストリーミング購読",
    streamDesc1: "カードの有効性の変更をリアルタイムで監視する",
    streamDesc2: "システムは新しいカード情報を自動的に更新します",
    membership: "メンバーのリチャージ",
    membershipDesc1: "自動更新なので何度も注文する必要がなく安心",
    membershipDesc2: "支出を柔軟に管理し、いつでも一時停止またはキャンセルできます",
    saas: "SaaSサービス",
    saasDesc: "視覚的なサブスクリプション ポートフォリオの構成",
    saasDesc1: "インテリジェントなサイクル課金",
    step: {
      title: "単品購入から長期購読まで",
      one: {
        title: "サブスクリプション パッケージの柔軟な選択",
        desc: "ユーザーのさまざまな消費習慣に合わせて、単一のサービスを週次、月次、年次のパッケージにアップグレードします。"
      },
      two: {
        title: "自動署名、バインド、保存",
        desc: "源泉徴収契約は、ユーザーが支払いを行うと、繰り返し操作することなく自動的に完了します。"
      },
      three: {
        title: "自動更新で安心管理",
        desc: "最初の控除が成功すると、システムは自動的に定期的に更新を実行し、異常な支払いに対してリアルタイムで警告を発します。"
      }
    },
    concactTitle: "サブスクリプション モデルを素早く解除してビジネスの成長を促進"
  },
  bnplPayment: {
    title: "今すぐ購入、後で支払い",
    desc1: "今すぐ購入して後払いの支払いサービスにアクセスする",
    desc2: "収益を増やす分割払いプラン",
    content: "世界をリードする BNPL ブランドに直接接続し、消費しきい値を下げ、注文コンバージョンを増加させます。",
    salesGrowth: {
      title: "消費者物価の閾値を下げる",
      title1: "取引額を効果的に増やす",
      customerPrice: {
        title: "顧客あたりの価格",
        desc: "平均 15% の改善*"
      },
      orderConversion: {
        title: "高額注文のコンバージョン率が高い",
        desc: "平均 10% の改善*"
      },
      industryPreference: {
        title: "業界の好みを効果的にターゲットにする",
        desc: "3C、美容、衣類、家具を選択する必要があります"
      },
      based: "*PingPong の内部顧客統計ソースに基づく"
    },
    step: {
      title: "3ステップで支払い完了",
      title1: "今すぐ購入、後で支払い0 お待ちください",
      one: {
        title: "分割払いプランを選択する",
        desc: "BNPLや分割払いなど、さまざまな支払いオプションから柔軟に選択できます。"
      },
      two: {
        title: "ワンクリックでの承認クォータの承認",
        desc: "今すぐ購入し、後で支払うアカウントにバインド/ログインして、リアルタイムの信用評価を完了します。"
      },
      three: {
        title: "支払いを完了する",
        desc: "ユーザーが取引を確認すると、販売者はリアルタイムで全額の支払いを受け取ります。"
      }
    },
    concactTitle: "今すぐ購入して後で支払いをすぐに解除して、ビジネスの成長を支援します"
  },
  linkPayment: {
    title: "定期購入のお支払い",
    desc1: "リンクを簡単に作成",
    desc2: "グローバルな支払いは効率的かつ安全です",
    content1: "開発は不要 |非常に高速な作成 |ワンクリックで世界中の顧客にアクセス",
    content2: "複数国の決済方法に対応｜ソーシャル/オフラインシーンでのシームレスな決済回収",
    support: "複数のシーンが利用可能",
    support1: "ワンクリックで即時支払いを生成",
    customer: "顧客サービスでの会話",
    customerDesc1: "オンラインカスタマーサービスはリアルタイムで支払いページをプッシュします",
    customerDesc2: "支払いはすぐに届きます",
    media: "ソーシャルメディア",
    mediaDesc1: "ソーシャルメディアプラットフォームでのワンクリック共有",
    mediaDesc2: "ファンはジャンプせずに支払いを完了できます。",
    email: "電子メールとSMS",
    emailDesc: "支払いメールのテンプレート",
    emailDesc1: "ワンクリック送信で支払いコンバージョン率が向上",
    step: {
      title: "コード不要、オムニチャネル支払い回収、",
      title1: "ビジネスは容易に拡大します",
      one: {
        title: "支払いリンクを作成する",
        desc: "3 つの簡単な手順で、プロフェッショナルな支払いリンクとブランド QR コードを作成し、1 回限りのトランザクションまたは長期的な再利用をサポートして、さまざまなビジネス ニーズを満たすことができます。"
      },
      two: {
        title: "支払いリンクを共有する",
        desc: "支払いリンクまたは QR コードは、電子メール、ソーシャル メディア、テキスト メッセージなどを介して共有でき、ブランドの請求書に埋め込むこともできます。"
      },
      three: {
        title: "支払いを完了する",
        desc: "支払いステータスのリアルタイム制御: バックグラウンドで取引の進行状況を直感的に表示し、支払い通知を即座に受け取り、キャッシュ フローを簡単に管理して、安定したビジネスの成長を支援します。"
      }
    },
    concactTitle: "リンク支払いのロックをすぐに解除してビジネスの成長を支援"
  },
  dcc: {
    desc1: "動的な通貨換算をサポート",
    desc2: "価格がより透明になり、支払いがより​​安全になります",
    content: "レジで 80 以上の通貨の自動変換をサポートし、消費者が現地通貨で迅速に支払うことができるようにします。オープンで透明な外国為替価格により、世界価格の一元管理が可能になります。",
    support: "現地通貨の価格設定を簡単に実現",
    support1: "支払いエクスペリエンスを効果的に向上させる",
    habit: "消費習慣に合わせて",
    habitDesc1: "現地通貨での価格設定は、海外の消費者の消費習慣により一致しています",
    time: "意思決定時間を短縮する",
    timeDesc1: "現地通貨による価格設定では、消費者が商品の価値を手動で計算する必要がありません。",
    timeDesc2: "購入決定までの時間を短縮する",
    rate: "注文コンバージョン率の向上",
    rateDesc: "国内通貨による価格設定と外貨による価格設定",
    rateDesc1: "注文コンバージョン率を平均で最大 5% 向上*",
    based: "*PingPong の内部顧客統計ソースに基づく",
    step: {
      title: "DCC はビジネスを可能にします",
      title1: "注文為替レート管理を簡単に実装",
      one: {
        title: "注文時に通貨ロックをサポートし、さまざまな期間のロック要件を満たすことができます。",
        desc: "さまざまな企業の注文為替レートのロックイン時間制限を満たし、消費者の取引意図を効果的に延長します。"
      },
      two: {
        title: "複数種類の国境を越えた支払いシナリオに適応できる、二通貨のスマートな選択",
        desc: "カード BIN に基づく現地通貨の自動識別をサポートし、DCC は消費者が現地通貨または外貨取引を独自に選択できるようにサポートします。"
      },
      three: {
        title: "透明な為替レートは、企業が為替レートのリスクを管理するのに効果的です",
        desc: "企業は取引前に為替価格を事前に取得し、為替コストを事前に評価し、為替リスクを効果的に管理できます。"
      }
    },
    concactTitle: "動的な通貨換算サービスを迅速に利用してビジネスの成長を支援します"
  },
  eCommerce: {
    introduce: {
      desc: "グローバルな電子商取引決済ソリューション",
      desc1: "企業の多様な取引シナリオをサポート",
      content: "自社構築の独立したWebサイト、マルチSAAS Webサイト構築システム、オープンソースのWebサイト構築システムなどをサポートします。"
    },
    experience: {
      title1: "チェックアウト体験を最適化する",
      title2: "ユーザーのコンバージョンを改善する",
      one: {
        title: "世界売上高",
        desc: "レジ係は世界中の購入者の言語とデバイスに自動的に適合し、複数の国際的な支払い方法をサポートし、スムーズなチェックアウト エクスペリエンスを生み出し、注文のチャーンを効果的に削減します。"
      },
      two: {
        title: "柔軟なスタイル",
        desc: "レジカウンターのパーソナライズカスタマイズをサポートし、レジカウンターとブランドの統一されたスタイルを実現します。"
      }
    },
    methods: {
      title1: "さまざまな支払いオプション",
      title2: "保証注文の変換",
      one: {
        title: "フレキシブルなクレジットカード商品",
        desc: "顧客の消費嗜好に合わせて、1 回限りのクレジット カード引き落とし、カードにリンクされた支払い、分割払い、その他の支払いソリューションをサポートしています。"
      },
      two: {
        title: "さまざまなローカライズされた決済ソリューション",
        desc: "各国のオンライン決済市場シェアに応じて、各国の消費習慣に合わせて消費者に現地のさまざまな決済方法をマッチングさせます。"
      },
      three: {
        title: "複数のBNPLクレジット商品をサポート",
        desc: "BNPL ブランド市場ランキングによると、消費者は安全で信頼できる BNPL 製品を使用し、消費閾値を下げることがサポートされています。"
      }
    },
    currency: {
      title1: "多通貨決済に対応",
      title2: "簡単に人民元エントリーを実現",
      desc: "国内外の決済ライセンスを保有し、米ドル、ユーロ、日本円、人民元などの主流通貨での決済に対応しています。"
    },
    concactTitle: "eコマース獲得ソリューションについて今すぐ学びましょう"
  },
  gaming: {
    introduce: {
      desc: "世界的なゲームパブリッシャーをサポート",
      desc1: "マルチシナリオ決済ソリューション"
    },
    scene: {
      one: {
        title: "完全なデバイス適応",
        desc: "PC、タブレット、携帯電話、その他のデバイスをサポート"
      },
      two: {
        title: "柔軟な控除モデル",
        desc: "ゲーム プロップ、メンバーシップ サブスクリプションなどをサポートします。",
        desc1: "さまざまな有料製品"
      },
      three: {
        title: "マーケティング戦略",
        desc: "ゲームの各種イベントマーケティング企画をサポート",
        desc1: "ゲーム収益の増加"
      }
    },
    payType: {
      title1: "複数の支払いタイプをサポート",
      title2: "さまざまな消費者の好みの支払い方法に対応します",
      card: {
        title: "クレジットカード決済",
        desc: "世界6つの主要カードグループをサポートし、世界中の消費者を迅速にカバー"
      },
      mobile: {
        title: "モバイル決済/電子ウォレット決済",
        desc: "Apple Pay、Google Pay、およびさまざまな国の主流の電子ウォレットをサポートし、ゲーム消費者の主な支払いニーズに対応します。"
      },
      prepaid: {
        title: "プリペイドカード決済",
        desc: "PaysafeCard やその他のプリペイド カードなどの支払い方法をサポートし、カードを持たない人々のゲーム消費ニーズに対応します"
      },
      carrier: {
        title: "キャリア決済",
        desc: "ゲーム運営者の支払い要件を満たし、オンライン支払いの可能性を最大限に高めます。"
      }
    },
    marketing: {
      title: "さまざまなゲームマーケティング活動をサポート",
      desc: "20% 以上の収益成長を達成*",
      discount: "ゲーム製品構成の割引",
      payDiscount: "支払いプロセス中のランダムな割引",
      orderDiscount: "注文割引活動",
      appDiscount: "海外決済アプリおよびその他のトラフィックの危険にさらされる",
      based: "*PingPong の内部顧客統計ソースに基づく"
    },
    concactTitle: "ゲーム取得ソリューションについて今すぐ学ぶ"
  },
  paymentPricing: { // AI（Codex）
    heroEyebrow: "決済方法の標準料金",
    heroTitle: "グローバルな決済方法と透明な料金を探索する",
    heroSubtitle: "取引ごとに、決済方法に応じた手数料を請求します。決済方法を除くその他のPingPong製品は、別途価格が設定されます。",
    sectionTitle: "最適な支払い方法を見つける",
    filterHint: "料金は加盟店の登録地によって異なる場合があります",
    merchantRegionLabel: "加盟店所在地",
    consumerRegionLabel: "取引国・地域",
    searchMethodLabel: "決済方法を検索",
    payMethodLabel: "決済方法",
    selectPlaceholder: "選択してください",
    searchPlaceholder: "決済方法を入力",
    versionLabel: "バージョン",
    publishDateLabel: "リリース日",
    thMethod: "決済方法",
    thCoverage: "取引国・地域",
    thRate: "決済方法の料金",
    tradeTypeTh: "取引タイプ",
    kycRegionTh: "加盟店所在地",
    transactionTypeTh: "取引タイプ",
    empty: "データなし",
    expandDetail: "詳細を展開",
    collapseDetail: "詳細を折りたたむ",
    scenarioTh: "取引シナリオ",
    regionTh: "取引国・地域",
    termTh: "期数",
    rateTh: "料金",
    quoteShape: {
      standard: "標準の単件手数料",
      scenarioQuote: "{count} 種類の取引シナリオ見積もり"
    },
    concactTitle: "今すぐグローバルアクワイアリングを開始"
  },
  contactUs: {
    globalization: "企業のグローバル化を支援",
    solutions: "高品質なグローバル決済ソリューションを提供",
    name: "名前",
    nameRule: "この項目は必須です。有効な名前を 2 ～ 30 文字の英字で入力します。",
    email: "仕事用メール",
    emailRule: "この項目は必須です。有効な電子メール アドレス example@domain.com を入力してください",
    phone: "電話",
    phoneRule: "この項目は必須です。正しい携帯電話番号を入力してください",
    company: "会社名",
    companyRule: "この項目は必須です。 2 ～ 30 文字の英数字の有効な名前を入力します。",
    link: "企業サイト・製品リンク",
    linkRule: "この項目は必須です。有効な URL を入力してください (例: https://www.pingpongx.com）。)",
    agreement1: "私は以下に基づいてピンポンに同意します",
    agreement2: "プライバシーポリシー",
    agreement3: "私の情報を処理するために、上記の情報は、PingPong が製品およびイベント情報を私に送信することを承認するためにのみ使用されます。",
    sales: "営業担当者に問い合わせる",
    submitSuccess: "送信成功",
    thank: "ご提出いただきありがとうございます。できるだけ早くご連絡いたします。",
    close: "閉鎖"
  },
  cookiePolicy: {
    title: "ピンポンクッキーポリシー",
    date: "最終更新日: 2025 年 5 月",
    desc1: "PingPong (<a href=https://www.pingpongx.com/zh/termsandConditions?channel=bing&inviteCode=ac-18&utm_source=bing-PC&utm_medium=pin-pai-ci-PC&utm_campaign=he-xin-ci&utm_term=pingpong&msclkid=1b12a230bf3b1f5f9a5cca1bb547799a&cb=true target=_blank>「PingPong 利用規約」</a> に定義) をお選びいただきありがとうございます。当社はお客様の個人情報とプライバシーの保護に努めており、お客様のプライバシーを真剣に受け止めています。この Cookie ポリシーにおける「お客様」とは、当社の Web サイトまたはアプリケーション (個別に「サイト」、総称して「サイト」) へのユーザーまたは訪問者を指します。",
    desc2: "このポリシーでは、当社のサイトが使用する Cookie およびその他の同様の (トラッキングなど) テクノロジー (ピクセルや SDK など) と、それらの使用方法について説明します。 Cookie は個人情報を収集する可能性があるため、当社のプライバシー ポリシーをお読みになり、当社がお客様の個人情報をどのように使用、保存、安全に保つかについて詳しく知ることをお勧めします。",
    section1: {
      title: "クッキーとは何ですか?",
      desc: "Cookie は、お客様が当社のサイトにアクセスしたときにコンピューターまたはその他のデバイス (携帯電話など) に保存される単純なテキスト ファイルです。これにより、当サイトはあなたのデバイスを他のユーザーのデバイスから識別できるようになります。",
      desc1: "Cookieは「ファーストパーティ」Cookieと「サードパーティ」Cookieに分けられ、当サイトでは両方のタイプのCookieを使用しています。ファーストパーティ Cookie: 当社によってサイト上に設定され、当社のサイトによってのみ読み取り可能です。サードパーティ Cookie: 広告や分析などのサービスを提供するサードパーティによって設定されます。これらの第三者は、当社に提供する分析の一環として、お客様のデバイス ID、IP アドレス、またはサイトの使用に関するその他の情報を収集する場合があります。第三者がお客様のデータをどのように収集して使用するかについては、以下をご覧ください。",
      google: '<a href="https://policies.google.cn/technologies/partner-sites?hl=en" target="_blank">https://policies.google.cn/technologies/partner-sites?hl=en</a>'
    },
    section2: {
      title: "Cookie の使用には同意が必要ですか?",
      desc: "特定の特別な場合（通信の送信に Cookie が不可欠な場合、またはお客様が要求したサービスを提供するために厳密に必要な場合など）を除き、当社は Cookie を配置する前にお客様の同意を得ます。",
      desc1: "ページの下部にあるプライバシー設定センターから、いつでも Cookie の使用に対する同意を取り消したり、Cookie の設定を調整したりできます。設定を有効にするには、ページを更新する必要がある場合があることに注意してください。"
    },
    section3: {
      title: "どのような種類の Cookie が使用されますか?",
      desc: "当社のサイトにアクセスするたびに、Cookie を受け入れるか拒否するかを尋ねられます。その目的は、サイトがユーザーの設定 (ユーザー名、言語など) を一定期間記憶し、同じ訪問中にそれらの設定を繰り返し入力することを回避できるようにすることです。",
      desc1: "Cookie は一般的なタイプによって次のように分類されます。",
      table: {
        column: {
          title1: "クッキーの種類",
          title2: "使用"
        },
        data: [{
          type: "必須",
          purpose: "これらの Cookie は、当社がサイトを提供および運営するために厳密に必要であり、ユーザーが無効にしたり拒否したりすることはできません。無効にしないと、サイトの通常の機能や使用に影響します。これらの Cookie がないと、ページ間を移動したり、サイトの主要機能の一部を使用したりできなくなります。"
        }, {
          type: "機能的",
          purpose: "お客様の選択に基づいて当社がサイトを運営できるようにするため。たとえば、機能的 Cookie は設定 (言語設定など) を記憶します。"
        }, {
          type: "分析的",
          purpose: "当社およびサードパーティのサービスが、訪問者による当社 Web サイトの使用方法に関する統計を編集するために使用される集計データを収集できるようにします。"
        }, {
          type: "指向性",
          purpose: "これにより、当社の広告がお客様のニーズにより適切なものであることを確認できます。"
        }]
      }
    },
    'section4-1': {
      title: "必須の Cookie",
      table: {
        column: {
          title1: "クッキー名",
          title2: "説明する",
          title3: "有効期間",
          title4: "ドメイン名",
          title5: "ファーストパーティまたはサードパーティの Cookie"
        },
        data: [{
          name: 'fs_merchant',
          description: "S3 ファイルのアップロード検証に使用され、ユーザーが承認の下でファイルをアップロードできるようになります。",
          duration: "24時間",
          domain: ['.pingpongx.com'],
          firstOrThirdParty: "最初のパーティー"
        }]
      }
    },
    section4: {
      title: "ファンクショナルクッキー",
      table: {
        column: {
          title1: "クッキー名",
          title2: "説明する",
          title3: "有効期間",
          title4: "ドメイン名",
          title5: "ファーストパーティまたはサードパーティの Cookie"
        },
        data: [{
          name: 'vuepack',
          description: "ユーザーの多言語設定情報を記録するために使用されます",
          duration: "一時的なセッション",
          domain: ['.pingpongx.com'],
          firstOrThirdParty: "最初のパーティー"
        }, {
          name: 'Site',
          description: "ユーザーが現在訪問しているサイト情報を記録します",
          duration: "一時的なセッション",
          domain: ['.pingpongx.com'],
          firstOrThirdParty: "最初のパーティー"
        }, {
          name: '_SIGNUP',
          description: "ユーザー登録時に選択した位置情報を記録する",
          duration: "一時的なセッション",
          domain: ['.business.pingpongx.com'],
          firstOrThirdParty: "最初のパーティー"
        }, {
          name: '_gid',
          description: "公式ウェブサイトのアドレスソースレコード",
          duration: "長さ",
          domain: ['.pingpongx.com'],
          firstOrThirdParty: "最初のパーティー"
        }, {
          name: 'Optanon Consent',
          description: "Web サイトの Cookie の使用に関するユーザーの同意の選択と設定を保存します",
          duration: "長さ",
          domain: ['vn.pingpongx.com', 'bd.pingpongx.com', 'id.pingpongx.com', 'th.pingpongx.com', 'kr.pingpongx.com', 'international.pingpongx.com'],
          firstOrThirdParty: "第三者"
        }]
      }
    },
    section5: {
      title: "分析クッキー",
      table: {
        column: {
          title1: "クッキー名",
          title2: "説明する",
          title3: "有効期間",
          title4: "ドメイン名",
          title5: "ファーストパーティまたはサードパーティの Cookie"
        },
        data: [
        // {
        // 	name: 'acw_tc',
        // 	description: '大数据埋点，收集用户设备信息，用于记录用户行为数据',
        // 	duration: '30 分钟',
        // 	domain: ['.logbury.pingpongx.com'],
        // 	firstOrThirdParty: '第一方'
        // },
        {
          name: '_ga',
          description: "Facebookの追跡統計",
          duration: "長さ",
          domain: ['.pingpongx.com'],
          firstOrThirdParty: "第三者"
        }, {
          name: '_gcl_au',
          description: "Facebookの追跡統計",
          duration: "長さ",
          domain: ['.pingpongx.com'],
          firstOrThirdParty: "第三者"
        }, {
          name: 'ar_debug',
          description: "Googleの追跡統計",
          duration: "長さ",
          domain: ['.pingpongx.com'],
          firstOrThirdParty: "第三者"
        }, {
          name: '_bl_uid',
          description: "Alibaba Cloud ARMS、フロントエンドのパフォーマンス監視とトラブルシューティングに使用されます（後続のバージョンでは非推奨になります）",
          duration: "長さ",
          domain: ['.business.pingpongx.com'],
          firstOrThirdParty: "第三者"
        }, {
          name: '_fwb',
          description: "NAVER Web Counterサービスのトラフィック統計（NAVERは韓国最大のインターネット企業）",
          duration: "長さ",
          domain: [`.business.pingpongx.com`],
          firstOrThirdParty: "第三者"
        }
        // {
        // 	name: 'acw_tc',
        // 	description: '公司内部埋点追踪',
        // 	duration: '长期',
        // 	domain: [`.pingpongx.com`],
        // 	firstOrThirdParty: '第三方'
        // }
        ]
      }
    },
    section6: {
      title: "Cookieを管理するにはどうすればよいですか?",
      desc: "当社の Web サイトを使用するときは、Cookie を完全に制御できます。次の方法で、当社および当社のサードパーティパートナーによる Cookie の使用を制御または制限できます。",
      list: [{
        title: "ブラウザとデバイスの設定:",
        desc: "ブラウザとデバイスの設定を通じて Cookie を無効にします。 Cookie を無効にすることで、デバイスに保存されているすべての Cookie を削除できます。ただし、Cookie を無効にすると、これにより、一部のサービス機能が正常に動作しなくなる可能性があります。 以下は、頻繁に使用されるブラウザの Cookie 管理ページの接続です。リストにリストされていない場合は、ブラウザの公式が次のように説明します。",
        items: [{
          name: 'Google Chrome：',
          link: '<a href=https://support.google.com/chrome/answer/95647?hl=en target=_blank >https://support.google.com/chrome/answer/95647?hl=en</a>'
        }, {
          name: 'Apple Safari：',
          link: '<a href=https://support.apple.com/en-gb/guide/safari/sfri11471/mac target=_blank >https://support.apple.com/en-gb/guide/safari/sfri11471/mac</a>'
        }, {
          name: ' Mozilla Firefox：',
          link: '<a href=https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox target=_blank >https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox</a>'
        }, {
          name: 'Microsoft Edge：',
          link: '<a href=https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies target=_blank >https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies</a>'
        }]
      }, {
        title: "EU および英国のユーザー:",
        desc: "当社サイトに必須ではない Cookie を設定する前に、プライバシー設定センターを通じて同意を求めます。すべての Cookie に同意したくない場合は、[「すべて拒否」] をクリックしてください。すべてではなく一部の Cookie に同意したい場合は、[「選択を確認する」] をクリックしてください。すべての Cookie を受け入れたい場合は、[すべて許可] をクリックしてください。"
      }],
      desc1: "お客様の権利の詳細については、<a href=https://www.pingpongx.com/zh/privacyPolicy?cb=true  target=_blank>プライバシー ポリシー</a>をご覧ください。"
    },
    section7: {
      title: "変更と改訂",
      desc: "当社は、この Cookie ポリシーを随時更新することがあります。更新されたバージョンは上記の「最終更新日」で示され、投稿された時点で有効になります。この Cookie ポリシーに重大な変更を加えた場合、変更の通知を目立つように掲載するか、お客様に直接通知を送信する場合があります。当社が Cookie をどのように使用するかを理解するために、この Cookie ポリシーを定期的に確認することをお勧めします。"
    },
    section8: {
      title: "お問い合わせ",
      desc: "EEA および英国以外のユーザー: 電子メール __XPH0__service@pingpongx.com</a> でお問い合わせください",
      desc1: "欧州経済領域ユーザー: 当社のデータ保護責任者 (DPO) は、__XPH0__dpo@pingpongx-eu.com</a> まで電子メールで、または郵送でご連絡いただけます。",
      european: ['PingPong Europe SA', 'Data Protection Department', 'Rue du Laboratoire 9 ', 'L-1911 Luxembourg'],
      desc2: "英国ユーザー: 当社のデータ保護責任者 (DPO) は、電子メール __XPH0__dpo-uk@pingpongx-uk.com</a> または郵送でご連絡いただけます。",
      uk: ['PingPong Payments (UK) Limited', 'Data Protection Department', '78 Cannon Street, London, England, EC4N 6HL', 'United Kingdom']
    }
  }
};
export default ja;
